import { gql, useMutation, useQuery } from '@apollo/client'
import { AdminUpdateStoryMutation, AdminUpdateStoryMutationVariables, AdminGetStoryQuery, AdminGetStoryQueryVariables } from 'types/graphql'

export const adminStoryFragment = gql`
  fragment AdminStoryFields on Story {
    id
    slug
    title
    document
    imageFullPath
    metaDescription
    publishedAt
    status
    authorId
    categoryIds
    createdAt
    categories {
      id
      name
      slug
      parentId
    }
    author {
      id
      fullName
      jobTitle
      avatarFullPath
      username
    }
  }
`

const editStoryMutation = gql`
  mutation AdminUpdateStory($id: Int!, $input: StoryInput!) {
    updateStory(id: $id, input: $input) {
      ...AdminStoryFields
    }
  }
  ${adminStoryFragment}
`

const getStoryQuery = gql`
  query AdminGetStory($id: Int) {
    story(id: $id) {
      ...AdminStoryFields
    }
  }
  ${adminStoryFragment}
`

export const useUpdateStory = () => {
  const [updateStory, { data, loading, error }] = useMutation<AdminUpdateStoryMutation, AdminUpdateStoryMutationVariables>(editStoryMutation)
  return { updateStory, data, loading, error }
}

export const useStory = (id: number) => {
  return useQuery<AdminGetStoryQuery, AdminGetStoryQueryVariables>(getStoryQuery, {
    variables: {
      id
    }
  })
}
